module.exports = __webpack_public_path__ + "img/gr8.b417a812.png";